import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NewsletterFormComponentDef } from '@df/session/newsletter/newsletter-form.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ButtonStyleComponent } from '../buttons/button-style/button-style.component';
import { FormFieldComponent } from '../form/field/form-field.component';
import { ResultComponent } from '../result/result.component';

@Component({
    imports: [FormsModule, FormFieldComponent, ButtonStyleComponent, ResultComponent, TranslatePipe],
    selector: 'newsletter-form',
    templateUrl: './newsletter-form.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterFormComponent extends NewsletterFormComponentDef {
    @Output()
    onSubmitSuccess = new EventEmitter<boolean>();

    get canSubmit() {
        return (this.data.email?.trim()?.length || 0) > 0;
    }

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.app.client.obs.breakpoint.subscribe(() => this.detectChanges()));
    }

    protected override onSuccess(): void {
        super.onSuccess();
        this.onSubmitSuccess.emit(true);
    }
}
